import React, { createContext, useContext, useState, useEffect } from "react";

// Tworzymy kontekst
const AuthContext = createContext();

// Hook do używania kontekstu
export const useAuth = () => {
  return useContext(AuthContext);
};

// Komponent dostarczający kontekst dla aplikacji
export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userRole, setUserRole] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [authToken, setAuthToken] = useState(null);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");

    if (token) {
      try {
        const decodedToken = JSON.parse(atob(token.split(".")[1])); 
        setIsLoggedIn(true);
        setUserRole(decodedToken.role || ""); 
        setUserEmail(decodedToken.email || ""); 
        setAuthToken(token); 
        console.log("User logged in:", decodedToken);
      } catch (error) {
        console.error("Invalid token format:", error);
        setIsLoggedIn(false);
      }
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const login = (token) => {
    sessionStorage.setItem("authToken", token);
    const decodedToken = JSON.parse(atob(token.split(".")[1])); 
    setIsLoggedIn(true);
    setUserRole(decodedToken.role || "");
    setUserEmail(decodedToken.sub || "");
    setAuthToken(token);
    
  
    console.log("User logged in with token:", decodedToken);
    console.log("User role:", decodedToken.role);
    console.log("User email:", decodedToken.email);
  };

  const logout = () => {
    sessionStorage.removeItem("authToken"); 
    setIsLoggedIn(false);
    setUserRole("");
    setUserEmail("");
    setAuthToken(null);
    
    console.log("User logged out");
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, userRole, userEmail, authToken, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
